import { TooltipRenderProps } from "react-joyride";
import s from "./style.module.scss";
import { UIButton } from "../UIButton/UIButton";
import crossIcon from "../../assets/cross.svg";

export const CustomTooltip = (props: TooltipRenderProps) => {
  const { closeProps, continuous, primaryProps, step, tooltipProps } = props;
  return (
    <div className={s.tooltip} {...tooltipProps}>
      <button className={s.close} {...closeProps}>
        <img src={crossIcon} alt="Close" className={s.icon} />
      </button>

      <div className={s.text}>{step.content}</div>
      <div className="tooltip__footer">
        <div className="tooltip__spacer">
          {continuous && (
            <UIButton
              fontType={"primary-1"}
              color={"light-green-2"}
              className={s.button}
              {...primaryProps}
              title="Дальше"
            >
              {step.target === "#profile" || step.target === "#profilemob"
                ? "Отлично"
                : "Дальше"}
            </UIButton>
          )}
        </div>
      </div>
    </div>
  );
};
